import { Badge } from 'react-bootstrap';

interface OrchestratorTagProps {
  workflowAlias?: string;
}

export const OrchestratorTag = ({ workflowAlias }: OrchestratorTagProps) => {
  const getBadgeVariant = (alias: string): string => {
    switch (alias) {
      case 'inmo':
        return 'info';
      case 'market-maker':
        return 'secondary';
      default:
        return 'secondary';
    }
  };

  const displayAlias = workflowAlias || 'market-maker';

  return (
    <Badge bg={getBadgeVariant(displayAlias)} className="fs-7">
      {displayAlias}
    </Badge>
  );
};
